import create from "zustand";

type SessionStoreState = {
	isExpired: boolean;
	setIsExpired: (isExpired: boolean) => void;
};

export const useSessionStore = create<SessionStoreState>((set) => ({
	isExpired: false,
	setIsExpired: (isExpired) => set({ isExpired }),
}));
